import React from "react";
import TabPanel from "../Reusable/Tab";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import EditVehicle from "./EditVehicle";

const Switchtab = (props: any) => {
  const { handleEdit, isLoading, refetch } = props;
  return (
    <>
      <TabPanel
        tabTitle={["Vehicle Update", "Documents"]}
        tabPanels={[
          <>
            <EditVehicle
              handleEdit={handleEdit}
              isLoading={isLoading}
              refetch={refetch}
            />
          </>,
          <>
            <FileUpload object_id={props?.id} />
          </>,
        ]}
      />
    </>
  );
};

export default Switchtab;
